const ERROR_KEYS = {
  PV_ADMISSION_TEMPLATE_NAME_ALREADY_EXISTS: 'errors.name-already-exists',
  PV_ADMISSION_TEMPLATE_IN_USE: 'errors.template-in-use',
  PV_ADMISSION_TEMPLATE_LEGACY: 'errors.legacy-template',
  PV_ADMISSION_INVALID_DOCUMENT: 'errors.invalid-document',
  PV_ADMISSION_DOCUMENT_TOO_LARGE: 'errors.document-too-large',
}

const PREFIX = 'pv-admission-management'

// Malformed field errors of docxtemplater (details of
// PV_ADMISSION_INVALID_DOCUMENT), by id
const MALFORMED_FIELD_KEYS = {
  unclosed_tag: 'errors.unclosed-field',
  unopened_tag: 'errors.unopened-field',
  duplicate_open_tag: 'errors.duplicate-open-brace',
  duplicate_close_tag: 'errors.duplicate-close-brace',
}

// Field names are shown as in the document, between braces.
const formatFields = (fields) => fields.map((field) => `{${field}}`).join(', ')

// Fields a PV d'admission Word template can use (backend-catp
// app/usecases/pv-admission-templates/fields.js).
export const AVAILABLE_FIELDS = [
  'accord_cadre',
  'numéro_marché',
  'numéro_lot',
  'bon_commande',
  'type_véhicule',
  'numéro_chassis',
  'numéro_parc',
  'date_contrôle',
  'nom_constructeur',
  'address_constructeur',
  'siret_constructeur',
  'quantité',
  'adhérent',
  'date_émission',
]

// Returns the list of (translated) messages describing an API error.
export function getPVAdmissionErrorMessages(err, t) {
  const data = err && err.response && err.response.data
  const code = data && data.error

  if (code === 'PV_ADMISSION_INVALID_DOCUMENT') {
    const fieldErrors = (data.details || [])
      .filter((detail) => detail.tag)
      .map((detail) =>
        t(
          `${PREFIX}.${
            MALFORMED_FIELD_KEYS[detail.id] || 'errors.malformed-field'
          }`,
          { field: detail.tag }
        )
      )
    return [t(`${PREFIX}.${ERROR_KEYS[code]}`), ...fieldErrors]
  }
  if (ERROR_KEYS[code]) {
    return [t(`${PREFIX}.${ERROR_KEYS[code]}`)]
  }
  return [t(`${PREFIX}.errors.generic`)]
}

// Warnings of a document the API saves only once accepted
// (PV_ADMISSION_DOCUMENT_WARNINGS), with the staging key to send again; null
// for any other error.
export function getPVAdmissionDocumentWarnings(err) {
  const data = err && err.response && err.response.data
  if (!data || data.error !== 'PV_ADMISSION_DOCUMENT_WARNINGS') {
    return null
  }
  return {
    stagingKey: err.stagingKey,
    unknownFields: data.unknownFields || [],
    withoutFields: !!data.withoutFields,
  }
}

// Returns the list of (translated) messages describing document warnings.
export function getPVAdmissionWarningMessages(warnings, t) {
  if (warnings.withoutFields) {
    return [t(`${PREFIX}.warnings.without-fields`)]
  }
  return [
    t(`${PREFIX}.warnings.unknown-fields`, {
      fields: formatFields(warnings.unknownFields),
    }),
    t(`${PREFIX}.errors.available-fields`, {
      fields: formatFields(AVAILABLE_FIELDS),
    }),
  ]
}
